module.exports = __webpack_public_path__ + "img/logo.fe570a09.png";